module.exports = __webpack_public_path__ + "static/media/pic7.52bc13e4.jpg";